import React, { useRef, useEffect } from "react";
import Chart from "chart.js";

export default function CategoriasChart({ produccionCat }) {
    const categoriasChart = useRef();

    function generateChart() {
        new Chart(categoriasChart.current, {
            type: "doughnut",
            data: {
                datasets: [
                    {
                        label: "My First dataset",
                        data: produccionCat.map((cat) => cat.toneladas / 1000),
                        backgroundColor: ["#00b5e9", "#fa4251"],
                        hoverBackgroundColor: ["#00b5e9", "#fa4251"],
                        borderWidth: [0, 0],
                        hoverBorderColor: ["transparent", "transparent"],
                    },
                ],
                labels: produccionCat.map((cat) => cat.nombre),
            },
            options: {
                responsive: true,
                cutoutPercentage: 87,
                animation: {
                    animateScale: true,
                    animateRotate: true,
                },
                legend: {
                    display: false,
                    position: "bottom",
                    labels: {
                        fontSize: 12,
                        fontFamily: "Open Sans,sans-serif",
                    },
                },
                tooltips: {
                    titleFontFamily: "Open Sans",
                    xPadding: 15,
                    yPadding: 10,
                    caretPadding: 0,
                    bodyFontSize: 12,
                },
            },
        });
    }

    useEffect(() => {
        generateChart();
    });

    return (
        <div className='dashboard-column graph-column'>
            <div className='totales-header'></div>
            <div className='dashboard-block'>
                <canvas
                    ref={categoriasChart}
                    style={{ width: 150, height: 110 }}
                    className='circleChart'></canvas>
            </div>
        </div>
    );
}
